// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.avatar-wrap-CHgx0E{position:relative}.avatar-wrap-CHgx0E .avatar-zctdMt{cursor:default;width:80px;height:80px}.avatar-wrap-CHgx0E .mask-unn_lF{cursor:pointer;visibility:hidden;border-radius:100%;justify-content:center;align-items:center;width:100%;height:100%;display:flex;position:absolute;top:0}.avatar-wrap-CHgx0E .mask-unn_lF:hover{visibility:visible;background-color:rgba(22,22,26,.6)}.avatar-wrap-CHgx0E:hover .mask-unn_lF{color:#fff;visibility:visible;background-color:rgba(22,22,26,.6)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"avatar-wrap": `avatar-wrap-CHgx0E`,
	"avatarWrap": `avatar-wrap-CHgx0E`,
	"avatar": `avatar-zctdMt`,
	"mask": `mask-unn_lF`
};
export default ___CSS_LOADER_EXPORT___;
